import { Button, Card, Flex, Tooltip, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { styled } from "styled-components";
import { radius } from "@libertify/ui";

export const ProjectAnalyticsStatCard = ({
  title,
  percentage,
  count,
  label,
  color,
  percentageTooltip,
  countTooltip,
}: {
  title: string;
  percentage: number | string | null;
  count: number | null;
  label: string;
  color: string;
  percentageTooltip?: string;
  countTooltip?: string;
}) => {
  const { Text } = Typography;
  const { theme } = useAntTheme();
  return (
    <StyledAnalyticsCard
      $backgroundColor={theme.colorCardSecondaryRedesign}
      styles={{
        body: { padding: 10, height: "100%" },
      }}
    >
      <Flex
        vertical
        gap={16}
        justify="space-between"
        style={{ height: "100%" }}
      >
        <Text style={{ fontSize: 12 }}>{title}</Text>

        <Tooltip
          title={percentageTooltip}
          mouseEnterDelay={1}
          styles={{ body: { fontSize: 11 } }}
        >
          <Text
            style={{
              fontSize: "26px",
              fontWeight: 600,
              color: theme.colorBlack,
              fontStyle: "normal",
              lineHeight: "normal",
              letterSpacing: "-0.96px",
              marginTop: "-20px",
              cursor: "help",
            }}
          >
            {percentage != null ? `${percentage}%` : "--"}
          </Text>
        </Tooltip>

        <div>
          <Tooltip
            title={countTooltip}
            mouseEnterDelay={1}
            styles={{ body: { fontSize: 11 } }}
          >
            <Button
              type="primary"
              style={{
                backgroundColor: color,
                borderColor: color,
                borderRadius: radius.box,
                height: 60,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                padding: "10px 16px",
              }}
            >
              <Text
                style={{
                  fontSize: "26px",
                  fontWeight: 600,
                  letterSpacing: "-0,96px",
                  color: theme.colorWhite,
                  textAlign: "center",
                }}
              >
                {count ? count.toLocaleString() : "-"}
              </Text>
              <Text
                style={{
                  color: theme.colorWhite,
                  fontSize: "10px",
                  fontWeight: 400,
                  letterSpacing: "-0.39px",
                  marginTop: "-16px",
                }}
              >
                {label}
              </Text>
            </Button>
          </Tooltip>
        </div>
      </Flex>
    </StyledAnalyticsCard>
  );
};

export const StyledAnalyticsCard = styled(Card)<{ $backgroundColor: string }>`
  border-radius: ${radius.box}px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: none;
  height: 100%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;
